<template>
  <el-dialog
    :title="dialogType == 'add' ? '新增视频' : '编辑视频'"
    :visible.sync="showDialog"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :append-to-body="true"
    @close="close"
    width="50%"
  >
    <div class="dialog_box">
      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="dataInfo"
        label-width="0px"
      >
        <div class="list">
          <div class="list-li">
            <span class="li-label"><span class="require">*</span>视频名称:</span>
            <el-form-item prop="videoName">
              <el-input
                size="small"
                clearable
                style="width:100%"
                v-model.trim="dataInfo.videoName"
              ></el-input>
            </el-form-item>
          </div>
          <div class="list-li">
            <span class="li-label"><span class="require">*</span>视频介绍:</span>
            <el-form-item prop="videoIntroduce"> 
              <el-input
                size="small"
                clearable
                style="width:100%"
                v-model.trim="dataInfo.videoIntroduce"
              ></el-input>
            </el-form-item>
          </div>  
         <div class="list-li">
            <span class="li-label"><span class="require">*</span>上传人名称:</span>
            <el-form-item prop="upUserName">
              <el-input
                size="small"
                clearable
                style="width:100%"
                v-model.trim="dataInfo.upUserName"
              ></el-input>
            </el-form-item>
          </div>
          <div class="list-li">
            <span class="li-label">上传视频:</span>
            <div>
                <el-upload
                class="upload-demo"
                action=""
                :show-file-list="false"
                accept="video/mp4"
                :http-request="uploadVideo"
              >
                <el-button
                  size="small"
                  type="primary"
                  class="el-icon-upload2"
                  plain
                  >点击上传</el-button
                >
                <div slot="tip" class="el-upload__tip">只能上传mp4格式视频，且不超过1G</div>
              </el-upload>
              <div>{{ dataInfo.videoUrl }}</div>
            </div>
          </div>
       
        </div>
      </el-form>
      <div class="dialog_save_cancel_box">
        <div class="cancel_item_box" @click="close">取消</div>
        <div class="save_item_box" @click="saveClick('ruleForm')">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    dialogType: {
      type: String,
      default: () => {
        return "add";
      }
    },
    addResize: {
      type: Number,
      default: () => {
        return false;
      }
    },
    dialogInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    //这里存放数据
    return {
      rules: {
        videoName: [{ required: true, message: "请输入视频主题 ", trigger: "blur" }],
        videoIntroduce: [{ required: true, message: "请输入视频介绍 ", trigger: "blur" }],
        upUserName: [{ required: true, message: "请输入上传人名称 ", trigger: "blur" }]

      },
      showDialog: false,
      dataInfo: {
        upUserName: "",
        videoName: "",
        videoUrl: "",
        videoIntroduce: "",
        schoolId:this.$store.state.schoolId,
      }
    };
  },
  //监控data中的数据变化
  watch: {
    addResize: function(val) {
      if (val) {
        this.showDialog = true;
        this.dataInfo = this.dialogInfo;
      }
    }
  },
  //计算属性，类似于data概念
  computed: {},
  //方法集合
  methods: {
    uploadVideo(val) {
      // console.log(val,333)
      let fileUpload = val.file;
      // console.log(fileUpload,3334)
      // var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      this.fileUploadCos(fileUpload,1)
    },
    async fileUploadCos(event,num) {
      // console.log(event,22)
      let file = event;
      // let uploadResult = await this.$Common.fileUploadCos(file);
      let uploadResult = await this.$Common.fileUploadCosGrid(file);

      
      if (uploadResult.err) {
        this.$message.error('上传出错，请联系管理员')
             this.dataInfo.videoUrl = "";
      } else {
        console.log('上传成功', uploadResult.data);
       
          this.dataInfo.videoUrl = "https://" + uploadResult.data.Location;
        
      }
    },
    async uploadFile(val) {
      // let res = await this.$Common.fileUploadTencent(event);
      // console.log(res)
      // this.dataInfo.fileUrl = res.fileUrl;

      // console.log(val,333)
      let fileUpload = val.file;
      // console.log(fileUpload,3334)
      // var fileUpload = event.target.files[0];
      if (!fileUpload) {
        return;
      }
      // console.log(event.target.files,1111111111)
      // console.log(fileUpload,1111111112)
      // console.log(val.target.files[0],1111111113)
      this.fileUploadCos(fileUpload,2)
    },
    close() {
        this.$refs.ruleForm.resetFields();
        this.showDialog = false;
    },
    saveClick(formName) {
      if(this.dataInfo.videoName == "") {
        this.$message("请输入视频名称！");
        return;
      }

      this.$refs[formName].validate((valid) => {
          if (valid) {
            if (this.dialogType == "add") {
              this.uploadPrincipalClass();
            } else {
              this.editPrincipalClass();
            }
          } else {
            return false;
          }
        });
    },
    async uploadPrincipalClass() {
      let req = this.dataInfo;
      let res = await this.$Http.upReviewVideo(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "上传成功!"
        });
        this.showDialog = false;
        this.$emit("searchData", this.dataInfo);
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    },
    async editPrincipalClass() {
      let req = this.dataInfo;
      let res = await this.$Http.updateReviewVideo(req);
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: "编辑成功!"
        });
        this.showDialog = false;
        this.$emit("searchData", this.dataInfo);
      } else if (res.code == 101) {
      } else {
        this.$message({
          message: res.messsage,
          type: "error"
        });
      }
    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {},
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.list {
  width: 100%;
  .list-li {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    .li-label {
      height: 38px;
      width: 80px;
      flex: 0 0 80px;
      display: flex;
      align-items: center;
    }
    .require {
      font-size: 14px;
      font-weight: 400;
      color: #FF3A3A;
    }
  }
}
</style>